import NoDataBanner from "components/common/NoDataBanner";
import Typography from "components/common/Typography";
import { fetchRecentlyViewedData } from "components/features/Corp/CorpUser.Slice";
import { useTranslate } from "hooks/useTranslate";
import { isEmpty } from "lodash";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import RecentData from "./RecentData";
import "./RecentlyViewed.scss";

const RecentlyViewed = () => {
  const recentData: any = useAppSelector((state) => state.CorpDashboard.recentlyViewedData);
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const dataLength = isEmpty(recentData) ? "no-data-banner" : "";

  useEffect(() => {
    dispatch(fetchRecentlyViewedData({}));
  }, []);

  return (
    <div className="view-recent-data-component">
      <div className="view-recent-data-heading">
        <Typography variant={"body2"} showBold>
          {translate("common.recentlyViewed")}
        </Typography>
      </div>
      <div className={`view-recent-data-container ${dataLength}`}>
        {!isEmpty(recentData) ? (
          <>
            {Object.entries(recentData)?.map(([key, value]) => {
              return <RecentData key={key} keyCategory={key} dataList={value} />;
            })}
          </>
        ) : (
          <NoDataBanner noDataMessage={translate("common.noRecentlyViewedData")} />
        )}
      </div>
    </div>
  );
};
export default RecentlyViewed;
